import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { sendSubscription } from "../services/popup.services";
import { CataloguePopup } from "../entities/popup.entities";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { useTranslation } from "react-i18next";
import { ASSETS_URL } from "@commons-monorepo/index";

export const usePopup = () => {
  const { t } = useTranslation();
  const { storeMetadata } = useOutletContext<any>();
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [subscriptionEmail, setSubscriptionEmail] = useState<string>("");
  const [popup, setPopup] = useState<CataloguePopup | null>(null);
  const [isOk, setIsOk] = useState<boolean>(true);
  const { setCouponCode, couponCode, setCouponCodeEmail } = useCart();
  const [ itIsCopy, setItIsCopy ] = useState<boolean>(false);
  const backupImagePopupFirstPurchase = `${ASSETS_URL}/prod/web/popup/catalogue-popup-image-1.webp`;
  const backupGeneralText = t('firstPurchase.general_text')
  const backupTextButton = t('firstPurchase.button')

  useEffect(() => {
    const showFirstCoupon = localStorage.getItem("showFirstCoupon");
    if (!!storeMetadata?.offerAddon && !showFirstCoupon) {
      setPopup(storeMetadata.offerAddon);
      setShowPopup(true);
    }
  }, []);

  const isValidEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleSubscription = async () => {
    const sendEmailService = await sendSubscription(storeMetadata.ownerId, subscriptionEmail);
    if (sendEmailService) {
      setCouponCode(sendEmailService);
      setCouponCodeEmail(subscriptionEmail);
      localStorage.setItem(
        "firstCoupon",
        JSON.stringify({ email: subscriptionEmail, coupon: sendEmailService }),
      );
      localStorage.setItem("showFirstCoupon", "true");
    } else {
      setIsOk(false);
    }
  };

  const handleCopy = (code: string) => {
    navigator?.clipboard?.writeText(code);
    setItIsCopy(true);
  };

  return {
    isOk,
    showPopup,
    subscriptionEmail,
    popup,
    couponCode,
    backupImagePopupFirstPurchase,
    itIsCopy,
    backupGeneralText,
    backupTextButton,
    isValidEmail,
    handleClose,
    setSubscriptionEmail,
    handleSubscription,
    handleCopy,
  };
};
